import { MenuItem, Typography } from "@mui/material";
import { FunctionComponent } from "react";
import { Link } from "react-router-dom";
import { MenuButton } from "../../types/utils";

const style = {
  menuItem: {
    py: 2,
  },
  text: {
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "29px",
  },
  link: {
    color: "#000000",
    textDecoration: "none",
  },
};
const DropDownBurgerMenuButton: FunctionComponent<{
  menuButton: MenuButton;
}> = ({ menuButton }) => {
  return (
    <Link to={menuButton.link} style={style.link}>
      <MenuItem key={menuButton.link} onClick={menuButton.onClickCallback} sx={style.menuItem}>
        <Typography variant="h5" textAlign="center" sx={style.text}>
          {menuButton.text}
        </Typography>
      </MenuItem>
    </Link>
  );
};

export default DropDownBurgerMenuButton;
